function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M33.7732 31.2005L34.6732 36.0007L30.3981 33.1505C28.898 33.7505 27.248 34.0506 25.448 34.0506C20.1228 34.0506 15.6226 31.1255 14.2726 27.1503C14.0476 26.4003 13.8976 25.5753 13.8976 24.7503C13.8976 19.5751 19.0728 15.375 25.448 15.375C28.4481 15.375 31.1481 16.275 33.1731 17.7751C35.4982 19.5002 36.9983 21.9752 36.9983 24.7503C36.9983 27.2254 35.7983 29.4754 33.7732 31.2005Z",
  fill: "#ACB3BA"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M32.3543 20.5508H18.4789V22.4258H32.3543V20.5508Z",
  fill: "white"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M35.1307 24.0762H15.8551V25.9512H35.1307V24.0762Z",
  fill: "white"
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  d: "M32.3543 27.8262H18.4789V29.7012H32.3543V27.8262Z",
  fill: "white"
});

var _ref6 = /*#__PURE__*/React.createElement("path", {
  d: "M16.974 0C8.12372 0 0.998535 5.85017 0.998535 13.1254C0.998535 15.9754 2.12353 18.6006 3.99863 20.7006L2.42357 27.7508L8.27374 24.0757C10.7488 25.4257 13.7489 26.1757 16.974 26.1757C25.8242 26.1757 32.9494 20.3256 32.9494 13.0504C33.0244 5.85017 25.8242 0 16.974 0Z",
  fill: "#818392"
});

var _ref7 = /*#__PURE__*/React.createElement("path", {
  d: "M8.50383 15.7501C9.9536 15.7501 11.1289 14.5748 11.1289 13.125C11.1289 11.6753 9.9536 10.5 8.50383 10.5C7.05406 10.5 5.87878 11.6753 5.87878 13.125C5.87878 14.5748 7.05406 15.7501 8.50383 15.7501Z",
  fill: "#84DBFF"
});

var _ref8 = /*#__PURE__*/React.createElement("path", {
  d: "M16.9772 15.7501C18.427 15.7501 19.6023 14.5748 19.6023 13.125C19.6023 11.6753 18.427 10.5 16.9772 10.5C15.5274 10.5 14.3522 11.6753 14.3522 13.125C14.3522 14.5748 15.5274 15.7501 16.9772 15.7501Z",
  fill: "#84DBFF"
});

var _ref9 = /*#__PURE__*/React.createElement("path", {
  d: "M25.5298 15.7501C26.9795 15.7501 28.1548 14.5748 28.1548 13.125C28.1548 11.6753 26.9795 10.5 25.5298 10.5C24.08 10.5 22.9047 11.6753 22.9047 13.125C22.9047 14.5748 24.08 15.7501 25.5298 15.7501Z",
  fill: "#84DBFF"
});

function SvgChatActive(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 37,
    height: 37,
    viewBox: "0 0 37 37",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgChatActive);
export default __webpack_public_path__ + "static/media/ChatActive.9dedd58a.svg";
export { ForwardRef as ReactComponent };